module.exports = __webpack_public_path__ + "img/Group 214.2203ecf2.svg";